import React from "react";
import { twMerge } from "tailwind-merge";
import DetailPopover from "./DetailPopover";
 
const InfoCard = ({ label, value, labelStyle, valueStyle, popoverTextStyle = "", className}) => {
  return (
    <div
      className={twMerge(`bg-[#FFFFFF] rounded-[5px] px-[15px] py-[19px] drop-shadow-[0_0px_4px_rgba(0,0,0,0.09)]`,className)}
    >
      <div className={twMerge(`text-[#707070] font-[500] font-inter leading-[100%] mb-2 text-[11px] sm:text-[12px]  md:text-[13px] lg:text-[14px]`, labelStyle)}>
        {label}
      </div>
      <div className={twMerge(`font-[500] font-inter text-[16px] sm:text-[18px] md:text-[22px] lg:text-[25px] leading-[100%] mt-1 bg-gradient-to-b from-[#4E6CF0] to-[#8442E3] bg-clip-text text-transparent break-words)`, valueStyle)}>        
        <DetailPopover
          text={`${value}`}
          placement="top"
          textStyle={popoverTextStyle}
          outerContainerStyle="rounded-[0px]"
        >
          {value}
        </DetailPopover>
      </div>
    </div>
  );
};
 
export default InfoCard;